export default __webpack_public_path__ + "assets/fonts/d6fc39ccfbd1a93a67aa2c1830f52d76.woff";